import { render, staticRenderFns } from "./DeliverySpotPurchaseRuleDialog.vue?vue&type=template&id=0e5b79c3&scoped=true&"
import script from "./DeliverySpotPurchaseRuleDialog.vue?vue&type=script&lang=ts&"
export * from "./DeliverySpotPurchaseRuleDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DeliverySpotPurchaseRuleDialog.vue?vue&type=style&index=0&id=0e5b79c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5b79c3",
  null
  
)

export default component.exports